import { ConfigSchema } from '../fieldSpec';

export type WhichLoss = 'base' | 'live' | 'projected';
export type Emphasis = 'hero' | 'compact';

export interface ExpectedLossConfig {
  which: WhichLoss;
  label: string;
  emphasis: Emphasis;
  // Overrides the workspace currency; null → use data.currency. Not in the phase-1
  // form, but parsed/honoured so it round-trips and the runner can use it.
  currencyOverride: string | null;
}

export const defaultExpectedLossConfig: ExpectedLossConfig = {
  which: 'live',
  label: 'Expected loss',
  emphasis: 'hero',
  currencyOverride: null,
};

export const expectedLossConfigSchema: ConfigSchema = [
  {
    key: 'which',
    type: 'enum',
    label: 'Which loss',
    options: [
      { value: 'base', label: 'Base' },
      { value: 'live', label: 'Live' },
      { value: 'projected', label: 'Projected' },
    ],
  },
  { key: 'label', type: 'text', label: 'Label', placeholder: 'Expected loss' },
  {
    key: 'emphasis',
    type: 'enum',
    label: 'Emphasis',
    options: [
      { value: 'hero', label: 'Hero (large)' },
      { value: 'compact', label: 'Compact (inline)' },
    ],
  },
];

// Tolerant parse — defaults any missing/corrupt field (matches the runner).
export function parseConfig(raw: Record<string, unknown> | undefined | null): ExpectedLossConfig {
  const r = raw ?? {};
  const which: WhichLoss = r.which === 'base' || r.which === 'projected' ? r.which : 'live';
  const emphasis: Emphasis = r.emphasis === 'compact' ? 'compact' : 'hero';
  const label = typeof r.label === 'string' && r.label.trim() ? r.label : 'Expected loss';
  const currencyOverride = typeof r.currencyOverride === 'string' ? r.currencyOverride : null;
  return { which, label, emphasis, currencyOverride };
}
